export default import.meta.ROLLDOWN_FILE_URL_Co3X7E68cCCs3Bf1EatIfA